/** RSVP deadline rule, shared with the autosave validation (JUB-152). */
export function validateRsvpDeadline(
  deadline: string | null | undefined,
  eventDate: string | null | undefined,
  t: (key: string) => string,
): string | null {
  if (!deadline) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const deadlineDate = new Date(deadline);
  deadlineDate.setHours(0, 0, 0, 0);

  if (deadlineDate <= today) {
    return t("validation.deadlineMustBeFuture");
  }

  if (eventDate) {
    const eventDateObj = new Date(eventDate);
    eventDateObj.setHours(0, 0, 0, 0);
    if (deadlineDate > eventDateObj) {
      return t("validation.deadlineBeforeEvent");
    }
  }

  return null;
}
